














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import emitter from "@/lib/emitter";
import { PostFileData } from "@/types";
import { EVENTS } from "@/const";
import AddFiles from "@/components/CreatePost/components/AddFilesController";

@Component({
  name: "MediaPostEditView",
  components: { AddFiles },
})
export default class MediaPostEditView extends Vue {
  @Prop({ required: true })
  public readonly fileList!: PostFileData[];

  @Prop({ required: true })
  public readonly postData!: ContentSet;

  public showPublicButton: boolean = false;

  public created() {
    const onPriceChanged = ({
      recurringLevel,
      oneTimePackage,
    }: {
      recurringLevel: SubscriptionLevel | null;
      oneTimePackage: PaymentPackage | null;
    }) => {
      this.showPublicButton =
        this.postData.type !== ContentFeedTypeEnum.EVENT &&
        (recurringLevel?.pricePackage?.amount ?? oneTimePackage?.amount ?? 0) > 0;
    };
    emitter.on<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, onPriceChanged);
    this.$once("hook:beforeDestroy", () => emitter.off<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, onPriceChanged));
  }
}
